/** Keys are re-dispatched under this event while the arcade is open, so the app never sees them. */
export const ARCADE_KEY_EVENT = "arcade-key";

export interface ArcadeKey {
  key: string;
  code: string;
  down: boolean;
  repeat: boolean;
}

const SEQUENCE = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
];

export function advanceKonami(progress: number, key: string): { progress: number; complete: boolean } {
  const normalized = key.length === 1 ? key.toLowerCase() : key;
  if (normalized !== SEQUENCE[progress]) return { progress: 0, complete: false };
  const next = progress + 1;
  return { progress: next === SEQUENCE.length ? 0 : next, complete: next === SEQUENCE.length };
}

export function isEditableTarget(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    Boolean(
      target.closest(
        "input, textarea, select, [contenteditable]:not([contenteditable='false']), [role='textbox'], [role='combobox']",
      ),
    )
  );
}
